/**
 * En-tete flottant Stockomax
 * - etat "compact" des que la page a defile
 * - masquage au defilement vers le bas, reapparition vers le haut (si active dans les reglages)
 * - jamais masque si un menu, la recherche, le panier ou une modale est ouvert
 * - desactive si l'utilisateur demande moins d'animations
 * Lecture du defilement regroupee par requestAnimationFrame, ecouteur passif.
 */
(() => {
  const section = document.querySelector('.header-section');
  if (!section) return;

  const root = document.documentElement;
  const hideEnabled = section.querySelector('[data-sx-hide-on-scroll]') !== null;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const COMPACT_AT = 24;
  const HIDE_AFTER = 320;
  const DELTA = 8;

  let lastY = window.scrollY;
  let ticking = false;

  const somethingOpen = () =>
    Boolean(
      document.querySelector(
        'header-menu[aria-expanded="true"], .header [aria-expanded="true"], dialog[open], .menu-drawer-container[open], .search-modal[open], predictive-search-component[open]'
      )
    ) || section.querySelector(':focus-visible') !== null;

  const setHeight = () => {
    root.style.setProperty('--sx-header-offset', `${Math.round(section.getBoundingClientRect().height + 16)}px`);
  };

  const update = () => {
    ticking = false;
    const y = Math.max(window.scrollY, 0);

    section.toggleAttribute('data-sx-compact', y > COMPACT_AT);

    if (!hideEnabled || reduceMotion.matches || somethingOpen()) {
      section.removeAttribute('data-sx-hidden');
    } else if (Math.abs(y - lastY) > DELTA) {
      section.toggleAttribute('data-sx-hidden', y > lastY && y > HIDE_AFTER);
    }

    lastY = y;
    if (cartDialog && cartDialog.open) placeCart();
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  // Toute ouverture (menu, recherche, panier) reaffiche l'en-tete immediatement
  document.addEventListener('focusin', (event) => {
    if (section.contains(/** @type {Node} */ (event.target))) section.removeAttribute('data-sx-hidden');
  });

  /* Panier flottant aligne sur la carte de l'en-tete (iteration 9) :
     bord droit = bord droit de la carte, haut = bas de la carte + 8 px (meme logique que le mega-menu,
     qui descend de l'en-tete sans le recouvrir : l'icone panier et son compteur restent visibles). */
  const card = section.querySelector('#header-component') || section;
  const GAP = 8;
  const placeCart = () => {
    const r = card.getBoundingClientRect();
    const vw = document.documentElement.clientWidth || window.innerWidth;
    const hidden = section.hasAttribute('data-sx-hidden');
    const top = hidden ? GAP : Math.round(Math.max(r.bottom, 0) + GAP);
    const right = Math.max(GAP, Math.round(vw - r.right));
    root.style.setProperty('--sx-cart-top', `${top}px`);
    root.style.setProperty('--sx-cart-right', `${right}px`);
    root.style.setProperty('--sx-cart-width', `${Math.round(r.width)}px`);
  };

  const cartDialog = document.querySelector('.cart-drawer__dialog');
  if (cartDialog) {
    new MutationObserver(() => {
      if (cartDialog.open) {
        section.removeAttribute('data-sx-hidden');
        placeCart();
        requestAnimationFrame(placeCart);
      }
    }).observe(cartDialog, { attributes: true, attributeFilter: ['open'] });
  }
  section.addEventListener('transitionend', placeCart);
  window.addEventListener('resize', placeCart, { passive: true });

  new ResizeObserver(() => {
    setHeight();
    placeCart();
  }).observe(section);
  setHeight();
  update();
  placeCart();
})();
